import angular from 'angular';
angular.module('cloudX').directive('cxRouteSelect', [
  '$state',
  '$transitions',
  function($state, $transitions) {
    return {
      restrict: 'A',
      replace: 'true',
      link: function($scope, element, attributes) {
        var ref = element.attr('ui-sref');
        if (ref === $state.$current.name) {
          element.addClass('selected');
        }
        var deregisterTo = $transitions.onSuccess({ to: ref }, function(transition) {
          element.addClass('selected');
        });
        var deregisterFrom = $transitions.onSuccess({ from: ref }, function(transition) {
          element.removeClass('selected');
        });
        $scope.$on('$destroy', function() {
          deregisterTo();
          deregisterFrom();
        });
      },
    };
  },
]);
